import React, { useContext } from "react";

import Footer from "./footer";
import { useState, useEffect } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";


function LLPcompanyregistration() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email: parsedUser.email || "",
          user_contact_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })

   const [errors, setErrors] = useState({});

      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> ;// Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 5);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }


      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

       if (!newData.user_contact_number.trim()) {
         newErrors.user_contact_number = '*number is required.';
       } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
       }

      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };




      // const formPutPartenshipdeed = async (e) => {
      //    e.preventDefault();
      //        // ✅ Check if user is logged in
      //  // if (!token) {
      // //     alert("Please log in to continue.");
      // //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      // //    navigate('/login'); // 👈 Use this if you're using React Router
      // //    return;
      // // }
      //    if (!validateForm()) return;
       
      //     localStorage.setItem("bookingData", JSON.stringify(newData));

      // // Navigate to checkout
      // navigate('/checkout', {
      //    state: {
      //       service: service,

      //    }
      // });
          
      //  };

         const formPutPartenshipdeed = async (e) => {
          e.preventDefault();
      
          if (!validateForm()) return;
      
          try {
              const response = await PartenerSheepDeedService.llpRegistionForm(newData);
      
              console.log("API Success:", response);
      
              navigate("/thankyou");
      
              // Optional: reset form
              setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
      
          } catch (error) {
              console.error("API Error:", error);
              alert("Something went wrong!");
          }
      };



   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">Limited Liability Partnership (LLP) Registration</h1>
                        <p className="pdrl-text">Get LLP Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Within 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        {/* <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">200k+</span> <span>people trust us</span></p>
                        <h1 className="sk-text-color">Limited Liability Partnership (LLP) Registration</h1>
                        <p className="pdrl-text">Get LLP Registration for only <span className="text-color"> Rs.8251/- </span> <span>(Including GST)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center">Within 2 Weeks
. Transparent Pricing. No Hidden Fees
.</p> */}
                        <div className="couter-all">
                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Pan & TAN Registration</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>DIN for Directors</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/pf-and-esc-registration.svg" />
                                    <p>PF and ESIC Registration</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>LLP Registration
                           </h3><p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>


         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">

               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>



               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-4">
                     <img src="assets/img/service/service7-main-image.png" alt="" />
                  </div>
                  <div className="col-lg-8">
                     <p className="pd-text">The Limited Liability Partnership (LLP) is one of the most preferred business structures in India for entrepreneurs. It combines the advantages of both a Company and a Partnership Firm, offering a flexible and efficient model.</p>
                     <p className="pd-text">An LLP is a separate legal entity, responsible for its own assets. While it bears full liability for its obligations, the liability of its partners is limited to their agreed contribution to the LLP. A minimum of two partners is required to incorporate an LLP. To legally establish an LLP, it must be registered under the Limited Liability Partnership Act, 2008.</p>
                     <p className="pd-text">Ready to take your business to the next level? Dm2Legal's LLP Registration service is the perfect solution! With our smooth and hassle-free process, you’ll receive all the legal assistance you need to quickly register your LLP. Enjoy the peace of mind that comes with our professional service and set your business up for success!</p>
                  </div>
               </div>
               <div className="space20"></div>

            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="service-binifits9 sp0 last-section" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Comparison </h2>
                        <div className="space40"></div>
                        <h6 className="hedaing-text">All Service Comparison</h6>
                        <h3 className="hedaing-text-1">Proprietorship vs Limited Liability Partnership (LLP) vs Company</h3>
                        <div className="pro-llp-com-table">
                           <table>
                              <thead>
                                 <tr className="table-heading">
                                    <th>Features</th>
                                    <th>Proprietorship</th>
                                    <th>Partnership</th>
                                    <th>LLP</th>
                                    <th>Company</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>Ownership</td>
                                    <td>In a proprietorship, a single individual owns and manages the entire business, making all decisions and retaining full control and responsibility for its operations.</td>
                                    <td>A partnership involves two or more individuals (partners) who share the ownership, management, and responsibilities of the business. Each partner contributes to the business, and profits and losses are typically shared based on the terms outlined in the partnership agreement.</td>
                                    <td>In a partnership, partners generally have unlimited liability, meaning their personal assets can be used to settle business debts or liabilities. This differs from structures like a limited liability company (LLC), where personal assets are protected.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). Shareholders enjoy limited liability, meaning their personal assets are generally protected from the company's debts and liabilities.</td>
                                 </tr>
                                 <tr>
                                    <td>Definition</td>
                                    <td>A sole proprietorship is a business owned and operated by a single individual, who has full control over its operations and decisions.</td>
                                    <td>A partnership is a legal arrangement in which two or more individuals or entities come together to share ownership, responsibilities, profits, and liabilities of a business.</td>
                                    <td>An LLP (Limited Liability Partnership) is a hybrid business structure that combines aspects of both partnerships and companies. It provides limited liability to its partners, meaning their personal assets are protected from the business’s liabilities.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). It can be structured as a private limited company or a public limited company. Shareholders are the owners of the company, and their liability is limited to their investment in the company.</td>
                                 </tr>
                                 <tr>
                                    <td>Registration Time</td>
                                    <td></td>
                                    <td></td>
                                    <td>7-15 working days</td>
                                    <td></td>
                                 </tr>
                                 <tr>
                                    <td>Promoter Liability</td>
                                    <td></td>
                                    <td>Unlimited Liability</td>
                                    <td></td>
                                    <td>Limited Liability</td>
                                 </tr>
                                 <tr>
                                    <td>Governance</td>
                                    <td>Governed by Local Laws</td>
                                    <td>Under Partnership Act, 1932</td>
                                    <td>LLP Act, 2008</td>
                                    <td>Under Companies Act,2013</td>
                                 </tr>
                                 <tr>
                                    <td>Compliance Requirements</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/LLP-Registration.png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon box-icon">
                              <img src="assets/img/icons/service6-icon1.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Limited Liability</a></h4>
                           <p className="font-f-7">In an LLP, the partners enjoy limited liability, meaning their personal assets are protected in the event of business debts or legal obligations. The partners' liability is restricted to their agreed-upon contribution to the LLP, ensuring that their personal assets remain safe.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon2.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Separate Legal Entity</a></h4>
                           <p className="font-f-7">An LLP is a distinct legal entity separate from its partners. It has the capacity to own assets, enter into contracts, and initiate or defend legal actions in its own name. This separation ensures a clear distinction between personal and business matters.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Easy Formation and Maintenance</a></h4>
                           <p className="font-f-7">Registering an LLP is a simple and straightforward process compared to other business structures like companies. With fewer compliance requirements and ongoing obligations, it reduces the administrative burden and associated costs.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon5.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Flexibility in Ownership and Management</a></h4>
                           <p className="font-f-7">LLPs offer flexibility in both ownership and management. Partners can decide the profit-sharing ratio and the decision-making process within the LLP. Additionally, they have the ability to admit new partners or remove existing ones, as outlined in the LLP agreement.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">No Minimum Capital Requirement</a></h4>
                           <p className="font-f-7">LLPs do not have a mandatory minimum capital requirement. Partners can contribute capital based on their agreement, allowing for easier business initiation and operation with fewer financial obligations.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/brand6-4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Taxation Benefits</a></h4>
                           <p className="font-f-7">LLPs benefit from pass-through taxation, meaning the LLP itself is not taxed at the entity level. Instead, partners are individually taxed on their share of profits or income, avoiding the issue of double taxation that companies may encounter.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Partner Liability Protection</a></h4>
                           <p className="font-f-7">LLP registration provides protection to partners by ensuring they are not personally liable for the wrongful acts or misconduct of other partners. Each partner is only responsible for their own actions and is not held liable for the actions of others in the partnership.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/work6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Increased Credibility</a></h4>
                           <p className="font-f-7">Registering as an LLP boosts the credibility and trustworthiness of the business. It establishes a formal legal structure, which can be advantageous when engaging with clients, suppliers, lenders, and other stakeholders.</p>
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </div>

         <Testimonials />

         <div className="service-binifits9 sp0" id="service2">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space50"></div>
                        <h2 className="text-center">Registration Process</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/Group-8586.png" alt="" />
                     </div>
                     <div className="space50"></div>
                  </div>
               </div>
            </div>
         </div>



         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space20"></div>
                              <div id="general">
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: What does Limited Liability Partnership (LLP) mean?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP is a hybrid business structure that combines features of a partnership and a company, where partners have limited liability and the firm has a separate legal identity.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: What are the basic requirements to register an LLP?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP needs at least 2 partners, 1 designated partner as an Indian resident, a unique name, a registered office, and must file LLP Agreement & incorporation documents with the MCA.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: Is it possible for an LLP to have just one partner?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          No, an LLP must have at least two partners. If one partner exits, a new one must be added to maintain LLP status.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: How does an LLP differ from a Private Limited Company?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">An LLP has limited liability and is easy to manage, with no mandatory audits. A Private Limited Company has shareholders, stricter compliance, and can raise funds through equity. </p>

                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: Is it possible to convert an LLP into a Private Limited Company?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    ><p className="font-f-3 weight-500">
                                          Yes, an LLP can be converted into a Private Limited Company by complying with Companies Act, 2013, obtaining MCA approval, and filing necessary forms.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: Can NRIs or foreign nationals become partners in an LLP?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    > <p className="font-f-3 weight-500">
                                          Yes, NRIs and foreign nationals can be partners in an LLP, but they must comply with FEMA regulations and may need government approvals.                                       </p>
                                    </div>
                                 </div>


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: Is it possible for an LLP to change its registered office address?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, an LLP can change its registered office address by passing a resolution, updating the LLP Agreement, and filing Form LLP-3 and LLP-15 with the MCA.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: Is an LLP Agreement compulsory?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, an LLP Agreement is mandatory, as it defines the roles, rights, and responsibilities of partners and must be filed with the MCA using Form LLP-3.                                        </p>
                                    </div>
                                 </div>






                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />
      </div>

   );
}
export default LLPcompanyregistration;